import date from 'quasar/src/utils/date/date.js';import extend from 'quasar/src/utils/extend/extend.js';import Loading from 'quasar/src/plugins/loading/Loading.js';
import { defineComponent, reactive, ref } from "vue";
import { onBeforeRouteLeave, useRoute, useRouter } from "vue-router";
import { api } from "~/api/Api";
import { FindFileItemCommand, FindFilesInfoCommand } from "~/api/Common/Commands/FindFilesInfoCommand";
import { ShomeiEntry } from "~/api/data";
import { FindFilesInfoResult } from "~/api/data/Common/FindFIlesInfoResult";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import FilePreview from "~/components/FilePreview.vue";
import { MsgBox } from "~/components/MsgBox";
import { auth } from "~/core/Auth";
import { Log } from "~/extensions/utils";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { FileCode, FileFetchKb, PageID, ShakoKeiyakushaToShiyoushaKbn, userType } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
import { store } from "./store/ShomeiEntryStore";
const log = Log.create("ShomeiEntryCheckPage");
export default defineComponent({
    components: {
        FilePreview,
        BreadcrumbList
    },
    name: "ShomeiEntryCheckPage",
    beforeRouteEnter(to, from, next) {
        const fromScreen = from.name;
        const relatedScreens = ["shomei-list", "shomei-shinsei", "nyukyosha-detail"];
        if (relatedScreens.includes(fromScreen) || !from.name) {
            next();
            return;
        }
        next(false);
    },
    async setup() {
        let html = reactive({
            value: ""
        });
        const router = useRouter();
        const route = useRoute();
        const personal = reactive(myPageStore.personal);
        const shomei = reactive(new ShomeiEntry());
        const isMt = auth.isMt;
        const nyukyokeiyakuNo = ref();
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const addressAll = isMt
            ? `〒${store.shomeiEntry.postCodeKeiyaku}\r\n${store.shomeiEntry.adr1Keiyaku}${store.shomeiEntry.adr2Keiyaku}\r\n${store.shomeiEntry.bukenName}`
            : myPageStore.selectedNyukyokeiyaku?.addressAll;
        // 画面名取得
        const pageName = commonStore.pageName(PageID.shomeiShinseiEntryCheck);
        let shomeiNo = route.query.shomeiNo?.toString() ?? "";
        //ファイル関連
        const visibleFileDialog = ref(false);
        const blob = ref(null);
        const findFilesInfoCommand = new FindFilesInfoCommand();
        const result = ref(new FindFilesInfoResult());
        const fileList = ref([]);
        let fileId = ref("");
        // 入居者情報詳細画面に遷移したときにURLにパラメーターを追加
        onBeforeRouteLeave(to => {
            const no = String(nyukyokeiyakuNo.value);
            if (to.name === "nyukyosha-detail" && isMt && to.query.nyukyokeiyakuNo !== no) {
                return {
                    name: "nyukyosha-detail",
                    query: {
                        ...to.query,
                        nyukyokeiyakuNo: no
                    }
                };
            }
        });
        // クエリパラメータにshomeiNoが含まれていない かつ 入力画面からの遷移でない場合
        if ((isNullOrUndefined(shomeiNo) || shomeiNo === "") && !store.shomeiEntry.fromEntry) {
            if (auth.isMt) {
                router.push({ name: "nyukyosha-detail" });
            }
            else {
                router.push({ name: "shomei-room-list" });
            }
        }
        // 初期表示処理
        try {
            if (isMt) {
                let orgNyukyokeiyakuNo = route.query.orgNyukyokeiyakuNo?.toString() ?? "-1";
                myPageStore.selectedNyukyokeiyakuNo = Number(orgNyukyokeiyakuNo);
                nyukyokeiyakuNo.value = Number(route.query.nyukyokeiyakuNo);
            }
            if (typeof shomeiNo !== "undefined" && shomeiNo !== "") {
                await store.find(shomeiNo);
                if (store.shomeiEntry.shosikiSiteiKb === 1) {
                    // ファイル情報取得パラメータ設定
                    findFilesInfoCommand.ShomeiNo = shomeiNo;
                    findFilesInfoCommand.fileList = [new FindFileItemCommand(FileFetchKb.Storage, FileCode.ShomeiFile)];
                    // ファイル情報取得
                    result.value = await api.common.findFilesInfo(findFilesInfoCommand);
                    fileId.value = result.value.fileList[0].fileIdStr;
                }
            }
        }
        catch (ex) {
            log.error("setup", ex);
            if (ex.data.status !== 404) {
                await MsgBox.error(ex.data.errorMessage);
            }
        }
        extend(true, shomei, store.shomeiEntry);
        const getAddressShiyosha = () => {
            let address = "";
            if (!isNullOrUndefined(shomei.shinseishaPostcode)) {
                address += "〒" + shomei.shinseishaPostcode + "\r\n";
            }
            if (!isNullOrUndefined(shomei.shinseishaAdr1)) {
                address += shomei.shinseishaAdr1;
            }
            if (!isNullOrUndefined(shomei.shinseishaAdr2)) {
                address += "\r\n" + shomei.shinseishaAdr2;
            }
            if (!isNullOrUndefined(shomei.shinseishaAdr3)) {
                address += "\r\n" + shomei.shinseishaAdr3;
            }
            return address;
        };
        const openPreview = () => {
            visibleFileDialog.value = true;
        };
        const apply = async () => {
            try {
                Loading.show();
                await store.insert();
                await router.push({ name: "shomei-entry-complete" });
                store.clear();
                // 個人情報ストアのロード
                myPageStore.load();
                await myPageStore.waitForBasic();
            }
            catch (ex) {
                log.error("apply", ex);
                MsgBox.error(ex.message);
                if (ex.data !== null && ex.data.code === "error.mail") {
                    router.push({ name: "shomei-entry-complete" });
                }
            }
            finally {
                Loading.hide();
            }
        };
        return {
            html,
            personal,
            date,
            shomei,
            isMt,
            nyukyokeiyakuNo,
            isMultipleKeiyaku,
            userType,
            ShakoKeiyakushaToShiyoushaKbn,
            result,
            fileList,
            fileId,
            visibleFileDialog,
            blob,
            FileCode,
            shomeiNo,
            findFilesInfoCommand,
            pageName,
            PageID,
            addressAll,
            getAddressShiyosha,
            openPreview,
            apply
        };
    }
});
